import { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowUpIcon, FlexGap, IconButton, Paragraph, TextArea, tokens } from '@treams/treams-ui';

export function AgentChatComposer(props: {
	draft: string;
	disabled: boolean;
	placeholder?: string;
	onChange: (value: string) => void;
	onSubmit: (event: FormEvent) => void;
}) {
	const { t } = useTranslation();
	const canSubmit = !props.disabled && props.draft.trim().length > 0;

	return (
		<form
			onSubmit={(event) => {
				event.preventDefault();
				if (canSubmit) {
					props.onSubmit(event);
				}
			}}
		>
			<FlexGap flexDirection="column" gap={tokens.gap.group} width="100%">
				<TextArea
					value={props.draft}
					placeholder={props.placeholder ?? t('aiAgent.askPlaceholder')}
					disabled={props.disabled}
					onChange={props.disabled ? undefined : props.onChange}
					onKeyDown={(event) => {
						if (props.disabled) {
							return;
						}
						if (event.key === 'Enter' && !event.shiftKey && canSubmit) {
							props.onSubmit(event);
							event.preventDefault();
						}
					}}
					action={
						<IconButton
							type="primary"
							icon={<ArrowUpIcon />}
							disabled={!canSubmit}
							aria-label={t('goals.ai.input.submit')}
							onClick={(event) => {
								event.preventDefault();
								if (!canSubmit) {
									return;
								}
								(event.currentTarget as HTMLElement).closest('form')?.requestSubmit();
							}}
						/>
					}
				/>
				<Paragraph small textAlign="center" mb={0}>
					{t('aiAgent.disclaimer')}
				</Paragraph>
			</FlexGap>
		</form>
	);
}
